module.exports = __webpack_public_path__ + "static/img/4e.416ac3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/4e.jpg
// module id = SQfu
// module chunks = 0